import React from "react";
import helper from "../Utils/helpers";
import { HeaderListing, TableBody, MatchedTab } from "./BetsListing";

const OpenBetsDetails = ({
  filtered,
  type,
  sortbyTime,
  betinfo,
  betType,
  marketLabel,
  clearBets,
  desktop,
}) => {
  // Attach the market label so each row can show the sub-market name under
  // the selection (reference kingexch111 layout).
  const rows = (filtered || []).map((b) => ({ ...b, marketLabel: marketLabel || b.marketLabel }));

  const renderRows = (predicate) =>
    rows.map(
      (res, i) =>
        predicate(res) && (
          <TableBody
            key={i}
            res={res}
            betinfo={betinfo}
            helper={helper}
            type={type}
            betType={betType}
            clearBets={clearBets}
            desktop={desktop}
          />
        )
    );

  return (
    <>
      {/* Only "Matched" shows the light tab; UnMatched keeps a compact header */}
      {type === "UnMatched" ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "8px 12px",
            background: "#f1f1f1",
            color: "#111",
            fontSize: "13px",
            fontWeight: 700,
          }}
        >
          <span>Unmatched</span>
          <a
            id="cancelAll"
            href="javascript:void(0)"
            onClick={() => clearBets("")}
            className="trashcan"
            style={{ color: "#2789ce", fontSize: "12px" }}
          >
            Cancel All
          </a>
        </div>
      ) : (
        <MatchedTab />
      )}

      {sortbyTime ? (
        <div id="txnList" className="slip-list" style={{ display: "block" }}>
          <HeaderListing type="" type2={type} />
          {renderRows((res) => (type === "Matched" ? res.isMatched : !res.isMatched))}
        </div>
      ) : (
        <div id="txnList" className="slip-list" style={{ display: "block" }}>
          {rows.some(
            (res) => res?.betType === "back" && (type === "Matched" ? res?.isMatched : !res?.isMatched)
          ) && (
            <>
              <HeaderListing type={"Back"} type2={type} />
              {renderRows(
                (res) => res.betType === "back" && (type === "Matched" ? res.isMatched : !res.isMatched)
              )}
            </>
          )}
          {rows.some(
            (res) => res.betType === "lay" && (type === "Matched" ? res.isMatched : !res.isMatched)
          ) && (
            <>
              <HeaderListing type="Lay" type2={type} />
              {renderRows(
                (res) => res.betType === "lay" && (type === "Matched" ? res.isMatched : !res.isMatched)
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default OpenBetsDetails;
